import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import router from '@/router';
import asyncRoutes from '@/router/asyncRoutes';
import s from 'storejs';
import store from '@/store';
import { getlang } from '@/lang';
import { Message } from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { utilCookies } from '@/util/cookies';
import getPageTitle from '@/util/get-page-title';
import { currentSession } from 'api/common';
import { getUserInfo } from 'api/login';
import loading from '@/components/loading/loading';
NProgress.configure({
  showSpinner: false
});
// 路由白名单 不需要登录
export var loginFree = ['/login/index', '/login', '/resetPass', '/login/create-company', '/login/loginCompany', '/login/loginWarning', '/register/index', '/register/team', '/register/success'];
var login = '/login/index';
var register = '/register/index';
var loginCompany = '/login/loginCompany';
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var path, status, token, companyToken, isLogged, left_days, accessRoutes, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          path = to.path; // changeLanguage(to)
          NProgress.start();
          status = loginFree.filter(function (item) {
            return item === to.path;
          })[0];
          if (status) loading.open();
          // 等待语言包
          _context.next = 6;
          return getlang();
        case 6:
          document.title = getPageTitle(to.meta.title);
          // 获取登录Token
          token = utilCookies.getToken();
          companyToken = utilCookies.getCompanyToken();
          isLogged = token && companyToken; // 未登录个人
          if (!(!token && path !== login && path !== register)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", next({
            path: login
          }));
        case 12:
          if (!(!companyToken && !loginFree.includes(path))) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("return", next({
            path: loginCompany
          }));
        case 14:
          if (!(isLogged && path === loginCompany)) {
            _context.next = 16;
            break;
          }
          return _context.abrupt("return", next({
            path: '/'
          }));
        case 16:
          if (!(isLogged && (!store.getters.routes || !store.getters.routes.length))) {
            _context.next = 37;
            break;
          }
          _context.prev = 17;
          _context.next = 20;
          return currentSession().then(function (res) {
            var data = res.data;
            store.dispatch('permission/setPermissionList', data.permissions);
            store.dispatch('user/setUserInfo', data.user_info);
            store.commit('user/COMPANY_INFO', data.company_info);
            s.set('currentCompany', data.company_info);
            s.set('userInfo', data.user_info);
          }).catch(function (error) {
            Message.warning('Internal server error');
            utilCookies.removeToken();
            utilCookies.removeCompanyToken();
            return error;
          });
        case 20:
          left_days = store.state.user.company_info.left_days; // 权限过滤
          accessRoutes = filterAsyncRoutes(asyncRoutes, store.getters.permissionList);
          accessRoutes = menuFilter(accessRoutes, left_days);
          router.addRoutes(accessRoutes);
          store.dispatch('permission/setRoutes', accessRoutes);
          // 获取公司列表
          _context.next = 27;
          return getUserInfo();
        case 27:
          res = _context.sent;
          s.set('companyList', res.data.managed);
          s.set('userInfo', res.data.user_info);
          // 过期之后默认跳转企业管理
          if (!left_days) {
            next({
              path: '/settings/settings_company_manager'
            });
          } else {
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
          }
          _context.next = 37;
          break;
        case 33:
          _context.prev = 33;
          _context.t0 = _context["catch"](17);
          console.log(_context.t0);
          next("".concat(login, "?redirect=").concat(to.path));
        case 37:
          next();
        case 38:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[17, 33]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  NProgress.done();
  loading.close();
});

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(permissionList, route) {
  if (route.meta && route.meta.permission) {
    return permissionList.some(function (item) {
      return route.meta.permission.includes(item);
    });
  } else {
    return true;
  }
}
// author menu filter
function menuFilter(menu, isExpre) {
  var res = [];
  if (!isExpre) {
    menu.forEach(function (route) {
      if (route.path === '/settings') {
        route.children = [route.children[0]];
        res.push(route);
      }
    });
  } else {
    res = menu;
  }
  return res;
}
// Url language
// function changeLanguage(to) {
//   const lang = to.query.lang
//   const url = util.ridUrlParam(window.location.href, ['lang'])
//   if (lang && lang !== utilCookies.getLanguage()) utilCookies.setLanguage(lang)
//   if (lang) {
//     window.location.href = url
//     window.location.reload()
//   }
// }
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, permissionList) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(permissionList, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissionList);
      }
      res.push(tmp);
    }
  });
  return res;
}